import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  list: {
    marginTop: 16,
    background: 'white',
    padding: 20,
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    width: '100%',
  },

  notFound: {
    textAlign: 'center',
    padding: '24px 0',
  },
  ratingColData: {
    padding: '15px 8px',
    width: 100,
  },

  ratingColRating: {
    width: 150,
  },

  ratingColComment: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },

  options: {
    '& span:not(.material-icons)': {
      display: 'inline-block',
    },

    '& span.material-icons': {
      marginLeft: 8,
      fontSize: 22,
      cursor: 'pointer',
    },
  },
}));

export default styles;
